import { inferMimeTypeFromName } from './mimeFallback';

/**
 * Returns true when a file is audio or video by MIME prefix, with extension fallback when MIME is empty.
 * @param {{ mimeType?: string, fileName?: string }} params
 * @returns {boolean}
 */
export function isAudioOrVideoFile({ mimeType, fileName } = {}) {
  const normalized = (mimeType || '').toString().trim().toLowerCase();
  if (normalized.startsWith('audio/') || normalized.startsWith('video/')) {
    return true;
  }
  if (normalized) {
    return false;
  }
  const inferred = (inferMimeTypeFromName(fileName) || '').toLowerCase();
  return inferred.startsWith('audio/') || inferred.startsWith('video/');
}
